export default __webpack_public_path__ + "static/media/CobeeByPluxee.7c4b0dcc.png";